import React from "react";
import portfolio from "../assets/services.mp4";

const HeroSectionService = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap');

        .digital-experiences-text {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          background: linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: shimmer 4s linear infinite;
        }

        @keyframes shimmer {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .glass-tag {
          position: relative;
          font-family: 'Poppins', sans-serif;
          font-size: 0.78rem;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.88);
          padding: 9px 22px;
          border-radius: 100px;
          cursor: default;
          background: rgba(255, 255, 255, 0.06);
          backdrop-filter: blur(16px) saturate(180%);
          -webkit-backdrop-filter: blur(16px) saturate(180%);
          border: 1px solid rgba(255, 255, 255, 0.14);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.12),
            0 4px 20px rgba(0, 0, 0, 0.3),
            0 1px 8px rgba(18, 154, 220, 0.08);
          transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
          overflow: hidden;
        }

        .glass-tag::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(181,93,208,0.5), rgba(18,154,220,0.5), transparent);
          border-radius: 100px 100px 0 0;
        }

        .glass-tag:hover {
          transform: translateY(-3px);
          background: rgba(255, 255, 255, 0.11);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.18),
            0 8px 28px rgba(0, 0, 0, 0.35),
            0 2px 14px rgba(181, 93, 208, 0.18);
        }
      `}</style>

      <section
        id="home"
        className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 pt-2 pb-28"
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src={portfolio} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="flex flex-col min-h-screen items-center justify-center text-center px-4 pt-56 pb-16 z-10">
          {/* DESIGNING label */}
          <p
            className="text-sm sm:text-base font-medium uppercase mb-3"
            style={{
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: "0.42em",
              color: "#ffffff", // ✅ solid white
            }}
          >
            Design Build Grow.
          </p>
          {/* with Perfect Syntax */}
          <p
            className=" mt-1 mb-8"
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "12px",
             
              color: "#ffffff",
            }}
          >
            From branding to websites to digital marketing  everything you  <br />{" "} need to create and scale your brand in one place.
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroSectionService;
